import styled from '@emotion/styled';
import InfoTooltip from 'components/info_tooltip';
import { observer } from 'mobx-react';
import React from 'react';
import LeagueUserRow from './league_user_row';

const ZoneWrapper = styled.div`
  width: 500px;
  position: relative;
  @media (max-width: 500px) {
    width: 100%;
  }
`;

const ZoneTitle = styled.div`
  background: ${props => props.background};
  color: #FFF;
  font-weight: bold;
  margin: 5px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  i {
    margin-right: 5px;
  }
`;

const TooltipWrapper = styled.div`
  position: absolute;
  top: 18px;
  right: 10px;
`;

const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

@observer
class LeagueZone extends React.Component {
  render() {
    if (this.props.leagues.length === 0) return null;

    return (
      <ZoneWrapper>
        {
          this.props.showTooltip && (
            <TooltipWrapper>
              <InfoTooltip
                position='left'
                color='white'
              >
                {this.props.tooltipText}
              </InfoTooltip>
            </TooltipWrapper>
          )
        }
        {
          this.props.title && (
            <ZoneTitle
              background={this.props.background}
            >
              <i className={this.props.iconClass} />
              {this.props.title}
            </ZoneTitle>
          )
        }
        <Table>
          {
            this.props.leagues.map(userLeague => (
              <LeagueUserRow
                key={userLeague.id}
                userLeague={userLeague}
                userId={this.props.userId}
                promotionStatus={this.props.promotionStatus}
              />
            ))
          }
        </Table>
      </ZoneWrapper>
    );
  }
}

export default LeagueZone;